// extracted by mini-css-extract-plugin
export var backdrop = "style-mod--backdrop--5ccf2";
export var circle = "style-mod--circle--90a0d";
export var container = "style-mod--container--b19c4";
export var content = "style-mod--content--b6381";
export var description = "style-mod--description--f31f5";
export var divider = "style-mod--divider--714a1";
export var draggableSvg = "style-mod--draggable-svg--89397";
export var hideSecondContainer = "style-mod--hide-second-container--46ce1";
export var imagesContainer = "style-mod--images-container--82092";
export var secondContainer = "style-mod--second-container--4be0f";
export var secondSection = "style-mod--second-section--0fc85";
export var smallVideo = "style-mod--small-video--78f18";
export var step = "style-mod--step--231b0";
export var stepCount = "style-mod--step-count--8acf9";
export var stepPink = "style-mod--step-pink--edb4c";
export var stepSubtitle = "style-mod--step-subtitle--75894";
export var stepTitle = "style-mod--step-title--71600";
export var stepsContainer = "style-mod--steps-container--bea59";
export var textContainer = "style-mod--text-container--4eed4";
export var title = "style-mod--title--1155f";
export var videoContainer = "style-mod--video-container--801a1";
export var viewMore = "style-mod--view-more--eb65d";
export var viewMorePink = "style-mod--view-more-pink--2dc52";